import moment from "moment";
import {
  GET_SUMMARY,
  GET_FILE_LIST,
  GET_ELEMENT_PROPERTIES,
  GET_FIELDS,
  REMOVE_ELEMENT,
  GET_CONFIGURATION_LIST,
  GET_MATCH_LIST,
} from "./action";

const nameInitialState = {
  configId: "",
  configName: "",
  configurations: [],
  fields: [],
  firmwares: [],
  elementProperties: {
    dataTypes: [],
    fields: [],
    tags: [],
  },
  configurationList: { totalRows: 0, items: [] },
  files: { totalRows: 0, items: [] },
  matchList: [],
  valuesList: [],
  summary: {
    configuration: "",
    recipe: "",
  },
};

export const reducer = (state = nameInitialState, action) => {
  switch (action.type) {
    case GET_SUMMARY:
      return { ...state, summary: action.payload };
    case GET_ELEMENT_PROPERTIES:
      return { ...state, elementProperties: action.payload };
    case GET_FIELDS:
      return { ...state, fields: action.payload };
    case REMOVE_ELEMENT:
      let v = Object.assign({}, state, {
        configurations: [...state.filter((item) => item.id !== action.id)],
      });

      return state;
    case GET_FILE_LIST:
      return { ...state, files: action.payload };
    case GET_CONFIGURATION_LIST:
      return { ...state, configurationList: action.payload };
    case GET_MATCH_LIST:
      return { ...state, matchList: action.payload };
    default:
      return state;
  }
};
